import NotificationEnd from "./NotificationEnd";

export default NotificationEnd;